import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { PageTitleService } from '../services/page-title.service';

/** Resolves a nav/page key to the same label shown in the sidebar. */
@Pipe({
  name: 'navTitle',
  standalone: true,
})
export class NavTitlePipe implements PipeTransform {
  constructor(private pageTitleService: PageTitleService) {}

  transform(pageName: string | null | undefined): Observable<string> {
    return this.pageTitleService.getPageTitle(pageName || '');
  }
}
